import { render, staticRenderFns } from "./headerTpl.vue?vue&type=template&id=1ff2f206&scoped=true&"
import script from "./headerTpl.vue?vue&type=script&lang=js&"
export * from "./headerTpl.vue?vue&type=script&lang=js&"
import style0 from "./headerTpl.vue?vue&type=style&index=0&id=1ff2f206&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff2f206",
  null
  
)

export default component.exports